module.exports = __webpack_public_path__ + "static/media/approve.576398ec.svg";